import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaTelegramPlane,
  FaArrowUp,
  FaLink,
  FaBriefcase,
  FaShieldAlt,
  FaPaperPlane,
  FaUserCheck,
  FaFileAlt,
  FaUserFriends,
  FaBolt,
  FaGlobe,
  FaLock,
  FaMobileAlt,
  FaHeadset,
  FaHome,
  FaUserNurse,
  FaHotel,
  FaGraduationCap,
  FaQuestionCircle,
  FaBuilding,
  FaTruck,
  FaLaptopCode,
  FaCar,
  FaShoppingCart,
  FaOilCan,
  FaPlane,
  FaStar,
  FaChevronRight,
  FaPhoneAlt,
  FaEnvelope,
  FaCheckCircle,
  FaMapMarkerAlt
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../Pages/Images/GudnetNewLogo.webp";
import SupportContactForm from "../Common/SupportContactForm/SupportContactForm";
import "./Footer.css";

const Footer = () => {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleScroll = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setShowScrollTop(window.scrollY > 280);
      } else {
        setShowScrollTop(window.scrollY > 150);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    if (document.documentElement) {
      document.documentElement.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
    if (document.body) {
      document.body.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const socialLinks = {
    facebook: "https://www.facebook.com/share/p/1BgiipYTDu/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/p/DRuWFT8DMBI/?igsh=MW8zaXJrdmZqOW80bQ==",
    youtube: "https://youtube.com/shorts/IDkA5xvTggU?si=Qt94TZXxeN-cmQ7Q",
    telegram: "https://t.me/gulfworker",
    linkedin: "https://www.linkedin.com/company/gulfworker",
    whatsapp:
      "https://wa.me/97477651422?text=Hello%2C%0A%0AI%20found%20your%20contact%20on%20GulfWorker.net.%20I%20am%20interested%20in%20using%20your%20platform%20and%20would%20like%20assistance%20regarding%20CV%20posting%2C%20job%20posting%2C%20or%20manpower%20agency%20registration.%0A%0AKindly%20guide%20me%20with%20the%20process%2C%20requirements%2C%20and%20charges.%0A%0AThank%20you.",
  };

  return (
    <footer className="rf-footer">
      <Container fluid className="rf-container">
        
        {/* ================= MAIN TOP GRID BOX ================= */}
        <div className="rf-main-box">
          <Row className="g-0">
            
            {/* COLUMN 1: BRAND INFO */}
            <Col lg={3} md={6} className="rf-col rf-col-brand">
              <div className="rf-col-inner">
                <div className="rf-brand-logo">
                  <img src={Logo} alt="Gulf Worker" className="rf-logo-img" />
                </div>
                <p className="rf-brand-tagline">Your Global Job Partner</p>
                <p className="rf-brand-desc">
                  Connecting skilled professionals with trusted employers across the Gulf and beyond. Your dream job is just a click away.
                </p>

                <a
                  href={socialLinks.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rf-whatsapp-btn"
                  aria-label="WhatsApp Inquiry"
                >
                  <FaWhatsapp className="rf-wa-icon" />
                  <span>WhatsApp Inquiry</span>
                </a>

                <div className="rf-social-section">
                  <h6 className="rf-subheading">Follow Us</h6>
                  <div className="rf-social-icons">
                    <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="rf-social-btn fb" aria-label="Facebook"><FaFacebookF /></a>
                    <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="rf-social-btn insta" aria-label="Instagram"><FaInstagram /></a>
                    <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="rf-social-btn li" aria-label="LinkedIn"><FaLinkedinIn /></a>
                    <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="rf-social-btn yt" aria-label="YouTube"><FaYoutube /></a>
                    <a href={socialLinks.telegram} target="_blank" rel="noopener noreferrer" className="rf-social-btn tg" aria-label="Telegram"><FaTelegramPlane /></a>
                  </div>
                </div>
              </div>
            </Col>

            {/* COLUMN 2: QUICK LINKS */}
            <Col xs={6} md={6} lg={2} className="rf-col rf-col-links">
              <div className="rf-col-inner">
                <h5 className="rf-title">
                  <FaLink className="rf-title-icon" /> Quick Links
                </h5>
                <ul className="rf-list">
                  <li><Link to="/aboutus" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> About Us</Link></li>
                  <li><Link to="/alljobs" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Browse Jobs</Link></li>
                  <li><Link to="/allcandidates" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> For Employers</Link></li>
                  <li><Link to="/tips-news" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Career Advice</Link></li>
                  <li><Link to="/tips-news" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Blog & News</Link></li>
                  <li><Link to="/tips-news" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Resume Tips</Link></li>
                  <li><Link to="/tips-news" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Salary Guide</Link></li>
                  <li><Link to="/tips-news" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Visa Information</Link></li>
                  <li><Link to="/tips-news" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Interview Tips</Link></li>
                  <li><Link to="/terms-and-conditions" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Terms & Conditions</Link></li>
                  <li><Link to="/contactus" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> FAQs</Link></li>
                  <li><Link to="/contactus" onClick={scrollToTop}><FaChevronRight className="rf-arrow" /> Contact Us</Link></li>
                </ul>
              </div>
            </Col>

            {/* COLUMN 3: OUR SERVICES */}
            <Col xs={6} md={6} lg={2} className="rf-col rf-col-services">
              <div className="rf-col-inner">
                <h5 className="rf-title">
                  <FaBriefcase className="rf-title-icon" /> Our Services
                </h5>
                <ul className="rf-icon-list">
                  <li><FaHome className="rf-item-icon" /> Domestic Workers</li>
                  <li><FaUserNurse className="rf-item-icon" /> Healthcare</li>
                  <li><FaHotel className="rf-item-icon" /> Hospitality</li>
                  <li><FaBuilding className="rf-item-icon" /> Construction</li>
                  <li><FaTruck className="rf-item-icon" /> Logistics & Transport</li>
                  <li><FaBuilding className="rf-item-icon" /> Facility Management</li>
                  <li><FaShieldAlt className="rf-item-icon" /> Security</li>
                  <li><FaLaptopCode className="rf-item-icon" /> IT & Software</li>
                  <li><FaCar className="rf-item-icon" /> Drivers</li>
                  <li><FaShoppingCart className="rf-item-icon" /> Retail & Sales</li>
                  <li><FaOilCan className="rf-item-icon" /> Oil & Gas</li>
                  <li><FaPlane className="rf-item-icon" /> Aviation</li>
                </ul>
              </div>
            </Col>

            {/* COLUMN 4: WHY CHOOSE US */}
            <Col xs={12} md={6} lg={2} className="rf-col rf-col-why">
              <div className="rf-col-inner">
                <h5 className="rf-title">
                  <FaShieldAlt className="rf-title-icon" /> Why Choose Us
                </h5>
                <ul className="rf-icon-list">
                  <li><FaUserCheck className="rf-item-icon" /> Verified Employers</li>
                  <li><FaFileAlt className="rf-item-icon" /> Verified Job Listings</li>
                  <li><FaUserFriends className="rf-item-icon" /> Direct & Agency Hiring</li>
                  <li><FaBolt className="rf-item-icon" /> Fast Application Process</li>
                  <li><FaGlobe className="rf-item-icon" /> Jobs in Gulf & Worldwide</li>
                  <li><FaLock className="rf-item-icon" /> Secure Recruitment</li>
                  <li><FaMobileAlt className="rf-item-icon" /> Easy Online Application</li>
                  <li><FaHeadset className="rf-item-icon" /> Dedicated Support Team</li>
                  <li><FaUserCheck className="rf-item-icon" /> Verified Agencies</li>
                  <li><FaCheckCircle className="rf-item-icon" /> Transparent Pricing</li>
                  <li><FaMobileAlt className="rf-item-icon" /> Video Call & Direct Connect</li>
                  <li><FaGlobe className="rf-item-icon" /> Multi-Category Platform</li>
                </ul>
              </div>
            </Col>

            {/* COLUMN 5: CONTACT US / FORM */}
            <Col lg={3} md={12} className="rf-col rf-col-contact">
              <div className="rf-col-inner">
                <h5 className="rf-title">
                  <FaPaperPlane className="rf-title-icon" /> Contact Us
                </h5>
                <SupportContactForm compact inlineFields className="rf-footer-form" />
              </div>
            </Col>
          </Row>
        </div>

        {/* ================= STATS BAR (5 CARDS) ================= */}
        <div className="rf-stats-grid">
          <div className="rf-stat-card">
            <FaUserFriends className="rf-stat-icon" />
            <div className="rf-stat-info">
              <span className="rf-stat-val">10K+</span>
              <span className="rf-stat-lbl">Active Employers</span>
            </div>
          </div>
          <div className="rf-stat-card">
            <FaUserCheck className="rf-stat-icon" />
            <div className="rf-stat-info">
              <span className="rf-stat-val">25K+</span>
              <span className="rf-stat-lbl">Verified Workers</span>
            </div>
          </div>
          <div className="rf-stat-card">
            <FaGlobe className="rf-stat-icon" />
            <div className="rf-stat-info">
              <span className="rf-stat-val">50+</span>
              <span className="rf-stat-lbl">Countries Served</span>
            </div>
          </div>
          <div className="rf-stat-card">
            <FaBriefcase className="rf-stat-icon" />
            <div className="rf-stat-info">
              <span className="rf-stat-val">500K+</span>
              <span className="rf-stat-lbl">Successful Placements</span>
            </div>
          </div>
          <div className="rf-stat-card">
            <FaStar className="rf-stat-icon" />
            <div className="rf-stat-info">
              <span className="rf-stat-val">98%</span>
              <span className="rf-stat-lbl">Satisfaction Rate</span>
            </div>
          </div>
          <div className="rf-stat-card">
            <FaHeadset className="rf-stat-icon" />
            <div className="rf-stat-info">
              <span className="rf-stat-val">24/7</span>
              <span className="rf-stat-lbl">Dedicated Support</span>
            </div>
          </div>
        </div>

        {/* ================= FEATURES GRID (6 CARDS) ================= */}
        <div className="rf-features-grid">
          <div className="rf-feature-card">
            <FaLock className="rf-feat-icon" />
            <div className="rf-feat-text">
              <h6>Secure Platform</h6>
              <p>Your data is protected with top security</p>
            </div>
          </div>
          <div className="rf-feature-card">
            <FaFileAlt className="rf-feat-icon" />
            <div className="rf-feat-text">
              <h6>Easy Application</h6>
              <p>Apply in a few simple steps online</p>
            </div>
          </div>
          <div className="rf-feature-card">
            <FaGlobe className="rf-feat-icon" />
            <div className="rf-feat-text">
              <h6>Global Opportunities</h6>
              <p>Explore jobs in Gulf and worldwide</p>
            </div>
          </div>
          <div className="rf-feature-card">
            <FaUserCheck className="rf-feat-icon" />
            <div className="rf-feat-text">
              <h6>Verified Employers</h6>
              <p>All employers are verified & trusted</p>
            </div>
          </div>
          <div className="rf-feature-card">
            <FaMobileAlt className="rf-feat-icon" />
            <div className="rf-feat-text">
              <h6>Mobile Friendly</h6>
              <p>Access jobs anytime, anywhere</p>
            </div>
          </div>
          <div className="rf-feature-card">
            <FaHeadset className="rf-feat-icon" />
            <div className="rf-feat-text">
              <h6>Trusted Support</h6>
              <p>We're here to help you succeed</p>
            </div>
          </div>
        </div>

        {/* ================= DISCLAIMER BOX ================= */}
        <div className="rf-disclaimer-box">
          <FaShieldAlt className="rf-disc-icon" />
          <p className="rf-disc-text">
            <strong>Disclaimer:</strong> Gulf Worker is a recruitment platform that connects employers and job seekers. We do not guarantee employment, interviews, visa approvals, salary, or recruitment outcomes. All hiring decisions are made independently by employers. Paid services (for employers and premium candidates) provide access to additional features and support only, and do not guarantee any job offers or placement. Users are advised to verify all job offers and employer details before making any decisions or payments.
          </p>
        </div>

        {/* ================= BOTTOM BAR ================= */}
        <div className="rf-bottom-bar">
          <div className="rf-bottom-left">
            <Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link>
            <span className="rf-dot">|</span>
            <Link to="/terms-and-conditions" onClick={scrollToTop}>Terms & Conditions</Link>
            <span className="rf-dot">|</span>
            <Link to="/returns-refunds-cancellation" onClick={scrollToTop}>Refund Policy</Link>
            <span className="rf-dot">|</span>
            <Link to="/aboutus" onClick={scrollToTop}>About Us</Link>
          </div>
          <div className="rf-bottom-right">
            <span className="rf-sec-badge"><FaLock className="me-1" /> SSL SECURE</span>
            <span className="rf-sec-badge"><FaCheckCircle className="me-1" /> GDPR COMPLIANT</span>
            <span className="rf-pay-badge visa">VISA</span>
            <span className="rf-pay-badge mc">Mastercard</span>
          </div>
        </div>

        {/* ================= DEVELOPER & LANGUAGE SUB-FOOTER ================= */}
        <div className="rf-subfooter-bar">
          <div className="rf-subfooter-center">
            <p className="rf-subfooter-copyright">
              {t("footer.rights_reserved", "© 2020 Gulf Worker. All rights reserved.")}
            </p>
            <p className="rf-subfooter-dev">
              <a
                href="https://www.gudnet.in"
                target="_blank"
                rel="noopener noreferrer"
                className="rf-dev-link"
              >
                {t("footer.developed_by", "Developed by Gudnet Computers Pvt. Ltd. (www.gudnet.in)")}
              </a>
            </p>
          </div>
        </div>

        {/* SCROLL TO TOP FLOATING BUTTON */}
        {showScrollTop && (
          <button
            type="button"
            className="scroll-top"
            onClick={scrollToTop}
            title="Back to top"
            aria-label="Scroll to top"
          >
            <FaArrowUp />
          </button>
        )}

      </Container>
    </footer>
  );
};

export default Footer;
